/* Artavia — kalkulator tapety w rolkach (strona). Jedna ściana (ze skosem i występem) albo cały pokój z oknami i drzwiami.
   Pasy układa w rolkach od najdłuższego. Dobiera tapety z kolekcji przez sekcję akc-wzory. Konfiguracja w <script data-akt-config>. */
(function () {
  'use strict';

  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var SIZE_RE = /(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function num(v) { return parseFloat(String(v == null ? '' : v).replace(',', '.')); }
  function fmt(v, d) { return (Math.round(v * Math.pow(10, d || 0)) / Math.pow(10, d || 0)).toString().replace('.', ','); }
  function money(cents) { return (Math.round(cents) / 100).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł'; }
  function plural(n, one, few, many) {
    if (n === 1) return one;
    var d = n % 10, dd = n % 100;
    return (d >= 2 && d <= 4 && (dd < 12 || dd > 14)) ? few : many;
  }

  // --- geometria ściany: profil górnej krawędzi [x, wysokość] od lewego do prawego narożnika ---
  function profile(d) {
    var W = d.w, H = d.h, c = d.c, D = d.d;
    if (d.shape === 'prawy') return [[0, H], [D, H], [W, c]];
    if (d.shape === 'lewy') return [[0, c], [W - D, H], [W, H]];
    if (d.shape === 'dwa') { var s = (W - D) / 2; return [[0, c], [s, H], [s + D, H], [W, c]]; }
    return [[0, H], [W, H]];
  }
  function hAt(P, x) {
    if (x <= P[0][0]) return P[0][1];
    for (var i = 0; i < P.length - 1; i++) {
      var a = P[i], b = P[i + 1];
      if (x >= a[0] && x <= b[0]) return b[0] - a[0] < 1e-9 ? Math.max(a[1], b[1]) : a[1] + (b[1] - a[1]) * (x - a[0]) / (b[0] - a[0]);
    }
    return P[P.length - 1][1];
  }
  function maxIn(P, a, b) {
    var m = Math.max(hAt(P, a), hAt(P, b));
    P.forEach(function (p) { if (p[0] > a && p[0] < b) m = Math.max(m, p[1]); });
    return m;
  }
  function areaOf(P) {
    var s = 0;
    for (var i = 0; i < P.length - 1; i++) s += (P[i + 1][0] - P[i][0]) * (P[i][1] + P[i + 1][1]) / 2;
    return s;
  }
  function maxH(P) { return P.reduce(function (m, p) { return Math.max(m, p[1]); }, 0); }
  function stripLen(h, trim, raport) {
    var len = h + trim;
    return raport > 0 ? Math.ceil(len / raport) * raport : Math.ceil(len);
  }
  // pasy w rolkach od najdłuższego: krótkie pasy wychodzą z resztek
  function pack(all, rl) {
    var bins = [];
    all.slice().sort(function (a, b) { return b - a; }).forEach(function (L) {
      for (var j = 0; j < bins.length; j++) if (bins[j] >= L) { bins[j] -= L; return; }
      bins.push(rl - L);
    });
    return bins.length;
  }

  function init(root) {
    if (!root || root.__akt) return;
    root.__akt = true;
    var C = {};
    try { C = JSON.parse(root.querySelector('[data-akt-config]').textContent); } catch (e) { return; }
    function $(sel) { return root.querySelector(sel); }
    function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function val(sel) { var el = $(sel); return el ? String(el.value).trim() : ''; }
    function nv(sel) { return num(val(sel)) || 0; }

    var out = $('[data-akt-out]');
    var mode = 'sciana', shape = 'prosta', runId = 0, cartItems = [];
    var uidSvg = 'akt' + Math.random().toString(36).slice(2, 8);

    // --- dane z formularza ------------------------------------------------------
    function input() {
      var d = { mode: mode, raport: num(val('[data-akt-raport]')) || 0, extra: $('[data-akt-extra]').checked ? 1 : 0, trim: +C.trimCm || 10 };
      if (mode === 'sciana') {
        d.w = nv('[data-akt-w]'); d.h = nv('[data-akt-h]'); d.shape = shape;
        d.cRaw = val('[data-akt-c]'); d.dRaw = val('[data-akt-d]'); d.c = num(d.cRaw) || 0; d.d = num(d.dRaw) || 0;
        d.wyst = null;
        if ($('[data-akt-wyst]').checked) {
          var ws = nv('[data-akt-ws]'), wg = nv('[data-akt-wg]'), wxRaw = val('[data-akt-wx]');
          d.wyst = { s: ws, g: wg, x: wxRaw === '' ? (d.w - ws) / 2 : (num(wxRaw) || 0) };
        }
      } else {
        d.L = nv('[data-akt-pl]'); d.W = nv('[data-akt-pw]'); d.h = nv('[data-akt-ph]');
        d.dn = Math.max(0, Math.round(nv('[data-akt-dn]'))); d.dw = nv('[data-akt-dw]'); d.dh = nv('[data-akt-dh]');
        d.on = Math.max(0, Math.round(nv('[data-akt-on]'))); d.ow = nv('[data-akt-ow]'); d.oh = nv('[data-akt-oh]'); d.op = nv('[data-akt-op]');
      }
      return d;
    }
    function filled(d) { return d.mode === 'sciana' ? (d.w && d.h) : (d.L && d.W && d.h); }

    function validate(d) {
      if (d.mode === 'sciana') {
        if (d.w < 30 || d.h < 30) return 'Podaj szerokość i wysokość ściany (co najmniej 30 cm), żeby zobaczyć wynik.';
        if (d.w > 2000 || d.h > 500) return 'Sprawdź wymiary — ściana do 20 m szerokości i 5 m wysokości. Przy większych powierzchniach napisz do nas.';
        if (d.shape !== 'prosta') {
          if (d.cRaw === '') return 'Podaj C — wysokość ściany w najniższym miejscu (0, jeśli skos schodzi do podłogi).';
          if (d.c >= d.h) return 'C (wysokość najniższa) musi być mniejsza niż B (wysokość najwyższa).';
          if (d.dRaw === '') return d.shape === 'dwa' ? 'Podaj D — szerokość płaskiej góry ściany (0, jeśli skosy schodzą się w szczycie).' : 'Podaj D — odległość od narożnika do miejsca, gdzie zaczyna się skos.';
          if (d.d >= d.w) return 'D musi być mniejsze niż A (szerokość ściany). Jeśli skosu nie ma, wybierz „Prosta”.';
        }
        if (d.wyst) {
          if (d.wyst.s <= 0 || d.wyst.g <= 0) return 'Podaj szerokość i głębokość występu albo odznacz „Na ścianie jest występ”.';
          if (d.wyst.x < 0 || d.wyst.x + d.wyst.s > d.w + 0.01) return 'Występ nie mieści się na ścianie — sprawdź jego szerokość i odległość od lewego narożnika.';
        }
        return '';
      }
      if (d.L < 50 || d.W < 50 || d.h < 50) return 'Podaj długość, szerokość i wysokość pokoju (co najmniej 50 cm), żeby zobaczyć wynik.';
      if (d.L > 2000 || d.W > 2000 || d.h > 500) return 'Sprawdź wymiary — pokój do 20 m długości i 5 m wysokości. Przy większych pomieszczeniach napisz do nas.';
      if (d.dn && (d.dw <= 0 || d.dh <= 0)) return 'Podaj szerokość i wysokość drzwi albo wpisz 0 przy liczbie drzwi.';
      if (d.dn && d.dh >= d.h) return 'Drzwi nie mogą być wyższe niż pokój — sprawdź wysokość drzwi.';
      if (d.on && (d.ow <= 0 || d.oh <= 0)) return 'Podaj szerokość i wysokość okna albo wpisz 0 przy liczbie okien.';
      if (d.on && d.op + d.oh > d.h) return 'Okno z parapetem nie mieści się w wysokości pokoju — sprawdź wymiary okna.';
      return '';
    }

    // --- obliczenia dla danej rolki ----------------------------------------------
    function calc(d, rw, rl) {
      var strips = [], side = [], shortS = [], area, rect = null;
      if (d.mode === 'sciana') {
        var P = profile(d), w = d.wyst;
        for (var x = 0; x < d.w - 0.5; x += rw) strips.push(stripLen(maxIn(P, x, Math.min(d.w, x + rw)), d.trim, d.raport));
        if (w) {
          var k = Math.ceil(w.g / rw);
          for (var i = 0; i < k; i++) side.push(stripLen(hAt(P, w.x), d.trim, d.raport), stripLen(hAt(P, w.x + w.s), d.trim, d.raport));
        }
        area = areaOf(P) + (w ? w.g * (hAt(P, w.x) + hAt(P, w.x + w.s)) : 0);
        rect = { P: P };
      } else {
        var walls = [d.L, d.W, d.L, d.W], full = 0;
        walls.forEach(function (wl) { full += Math.ceil(wl / rw); });
        var fullLen = stripLen(d.h, d.trim, d.raport);
        var used = 0;
        for (var a = 0; a < d.dn; a++) {
          var kd = Math.floor(d.dw / rw); used += kd;
          for (var b = 0; b < kd; b++) if (d.h - d.dh > 1) shortS.push(stripLen(d.h - d.dh, d.trim, d.raport));
        }
        for (var o = 0; o < d.on; o++) {
          var ko = Math.floor(d.ow / rw); used += ko;
          for (var q = 0; q < ko; q++) {
            var top = d.h - d.op - d.oh;
            if (top > 1) shortS.push(stripLen(top, d.trim, d.raport));
            if (d.op > 1) shortS.push(stripLen(d.op, d.trim, d.raport));
          }
        }
        if (used > full) return { err: 'Okna i drzwi zajmują więcej miejsca niż ściany pokoju — sprawdź ich liczbę i szerokość.' };
        for (var f = 0; f < full - used; f++) strips.push(fullLen);
        area = 2 * (d.L + d.W) * d.h - d.dn * d.dw * d.dh - d.on * d.ow * d.oh;
      }
      var all = strips.concat(side, shortS);
      var longest = all.reduce(function (m, v) { return Math.max(m, v); }, 0);
      if (longest > rl) return { tooHigh: true, rl: rl };
      var perRoll = Math.floor(rl / longest);
      var rolls = pack(all, rl) + d.extra;
      // dla porównania: jak gdyby każdy pas był pełnej długości
      var rectRolls = Math.ceil(all.length / perRoll) + d.extra;
      if (d.mode === 'pokoj') rectRolls = Math.ceil((strips.length + used) / perRoll) + d.extra;
      return { rw: rw, rl: rl, strips: strips, side: side, shortS: shortS, all: all, longest: longest,
        shortest: all.reduce(function (m, v) { return Math.min(m, v); }, Infinity), perRoll: perRoll,
        rolki: rolls, rectRolls: rectRolls, area: Math.max(0, area) / 10000, rect: rect };
    }

    // --- podgląd ------------------------------------------------------------------
    function line(x, y1, y2, sw) {
      return '<line x1="' + x.toFixed(2) + '" y1="' + y1.toFixed(2) + '" x2="' + x.toFixed(2) + '" y2="' + y2.toFixed(2) + '" stroke="#202D3D" stroke-opacity=".45" stroke-width="' + sw + '" stroke-dasharray="' + (sw * 6) + ' ' + (sw * 4) + '"/>';
    }
    function previewWall(d, r) {
      var P = r.rect.P, Wt = d.w, Hm = maxH(P), sw = Math.max(0.6, Wt / 400);
      function Y(h) { return +(Hm - h).toFixed(2); }
      var poly = '0,' + Y(0) + ' ' + P.map(function (p) { return p[0] + ',' + Y(p[1]); }).join(' ') + ' ' + Wt + ',' + Y(0);
      var cid = uidSvg + 'c';
      var svg = '<svg viewBox="' + (-sw * 2) + ' ' + (-sw * 2) + ' ' + (Wt + sw * 4) + ' ' + (Hm + sw * 4) + '" role="img" aria-label="Ściana ' + d.w + ' na ' + d.h + ' cm podzielona na pasy">';
      svg += '<defs><clipPath id="' + cid + '"><polygon points="' + poly + '"/></clipPath></defs><polygon points="' + poly + '" fill="#ECE4D6"/>';
      var w = d.wyst;
      if (w) {
        svg += '<rect x="' + w.x + '" y="0" width="' + w.s + '" height="' + Hm + '" fill="#202D3D" fill-opacity=".13" stroke="#202D3D" stroke-opacity=".55" stroke-width="' + sw + '" clip-path="url(#' + cid + ')"/>';
        var fs = Math.max(8, Math.min(w.s * 0.26, Wt / 28)), cx = w.x + w.s / 2;
        svg += '<text x="' + cx + '" y="' + Y(hAt(P, cx) / 2) + '" font-size="' + fs.toFixed(1) + '" text-anchor="middle" dominant-baseline="middle" fill="#202D3D" fill-opacity=".7" font-family="inherit">występ</text>';
      }
      var ls = '';
      for (var x = r.rw; x < Wt - 0.5; x += r.rw) ls += line(x, 0, Hm, sw);
      svg += '<g clip-path="url(#' + cid + ')">' + ls + '</g>';
      svg += '<polygon points="' + poly + '" fill="none" style="stroke:var(--apk-accent)" stroke-width="' + (sw * 2.5) + '" stroke-linejoin="round"/></svg>';
      return '<div class="apk-preview">' + svg + '</div>';
    }
    // rozwinięcie czterech ścian pokoju z oknami i drzwiami (rozmieszczenie orientacyjne)
    function previewRoom(d, r) {
      var walls = [d.L, d.W, d.L, d.W], tot = 2 * (d.L + d.W), gap = tot / 60, TW = tot + gap * 3, H = d.h;
      var sw = Math.max(0.6, TW / 500), items = [[], [], [], []];
      for (var i = 0; i < d.dn; i++) items[i % 4].push({ t: 'd', w: d.dw, h: d.dh, y: 0 });
      for (var j = 0; j < d.on; j++) items[(j + 2) % 4].push({ t: 'o', w: d.ow, h: d.oh, y: d.op });
      var svg = '<svg viewBox="' + (-sw * 2) + ' ' + (-sw * 2) + ' ' + (TW + sw * 4) + ' ' + (H + sw * 4 + TW / 30) + '" role="img" aria-label="Rozwinięcie ścian pokoju z podziałem na pasy">';
      var x0 = 0, fs = TW / 50;
      walls.forEach(function (wl, k) {
        svg += '<rect x="' + x0 + '" y="0" width="' + wl + '" height="' + H + '" fill="#ECE4D6"/>';
        for (var x = r.rw; x < wl - 0.5; x += r.rw) svg += line(x0 + x, 0, H, sw);
        var m = items[k].length;
        items[k].forEach(function (it, n) {
          var cx = x0 + wl * (n + 1) / (m + 1);
          svg += '<rect x="' + (cx - it.w / 2).toFixed(2) + '" y="' + (H - it.y - it.h).toFixed(2) + '" width="' + it.w + '" height="' + it.h + '" fill="#FFFFFF" stroke="#202D3D" stroke-opacity=".6" stroke-width="' + sw + '"/>';
          svg += '<text x="' + cx.toFixed(2) + '" y="' + (H - it.y - it.h / 2).toFixed(2) + '" font-size="' + Math.min(fs, it.w / 4).toFixed(1) + '" text-anchor="middle" dominant-baseline="middle" fill="#202D3D" fill-opacity=".7" font-family="inherit">' + (it.t === 'd' ? 'drzwi' : 'okno') + '</text>';
        });
        svg += '<rect x="' + x0 + '" y="0" width="' + wl + '" height="' + H + '" fill="none" style="stroke:var(--apk-accent)" stroke-width="' + (sw * 2.5) + '"/>';
        svg += '<text x="' + (x0 + wl / 2).toFixed(2) + '" y="' + (H + fs * 1.4).toFixed(2) + '" font-size="' + fs.toFixed(1) + '" text-anchor="middle" fill="#202D3D" fill-opacity=".65" font-family="inherit">' + fmt(wl) + ' cm</text>';
        x0 += wl + gap;
      });
      return '<div class="apk-preview">' + svg + '</div>';
    }

    // --- wzory z kolekcji (sekcja akc-wzory) ---------------------------------------
    var wzoryCache = {};
    function loadWzory(tags, page) {
      if (!C.kolHandle) return Promise.resolve({ count: 0, page: 1, pages: 1, items: [] });
      var key = tags.join('+') + '|' + page;
      if (wzoryCache[key]) return wzoryCache[key];
      var url = ROOT_URL + 'collections/' + C.kolHandle + (tags.length ? '/' + tags.join('+') : '') +
        '?section_id=akc-wzory&sort_by=best-selling&page=' + page;
      wzoryCache[key] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
        .then(function (html) {
          var m = html.match(/<script[^>]*data-akc-wzory[^>]*>([\s\S]*?)<\/script>/);
          return m ? JSON.parse(m[1]) : { count: 0, page: 1, pages: 1, items: [] };
        })
        .catch(function () { delete wzoryCache[key]; return { count: 0, page: 1, pages: 1, items: [] }; });
      return wzoryCache[key];
    }
    // pomieszczenie + motyw, sam motyw, samo pomieszczenie, wszystkie — żeby zawsze coś pokazać
    function findWzory(room, motif) {
      var tries = [], seen = {};
      [[room, motif], [motif], [room], []].forEach(function (t) {
        t = t.filter(Boolean);
        var k = t.join('+');
        if (!seen[k]) { seen[k] = true; tries.push(t); }
      });
      var i = 0;
      function next() {
        var t = tries[i++];
        return loadWzory(t, 1).then(function (res) {
          if ((res.items && res.items.length) || i >= tries.length) return { tags: t, res: res, exact: i === 1 };
          return next();
        });
      }
      return next();
    }

    var calcCache = {};
    function wzorHtml(item, d, idx) {
      var v = null;
      (item.v || []).some(function (x) { if (x[4] !== false) { v = x; return true; } return false; });
      var href = item.u + (v ? (item.u.indexOf('?') === -1 ? '?' : '&') + 'variant=' + v[2] : '');
      var h = '<div class="akc-item"><a href="' + esc(href) + '" target="_blank" rel="noopener">' +
        (item.i ? '<img class="akc-img" src="' + esc(item.i) + '" alt="" width="84" height="84" loading="lazy">' : '<span class="akc-img"></span>') + '</a><div>';
      h += '<a class="akc-name" href="' + esc(href) + '" target="_blank" rel="noopener">' + esc(item.t) + '</a>';
      cartItems[idx] = null;
      if (v) {
        var m = SIZE_RE.exec(v[0] || ''), rw = m ? num(m[1]) : C.rollW, rl = m ? num(m[2]) : C.rollL;
        var key = rw + 'x' + rl, r = calcCache[key] || (calcCache[key] = calc(d, rw, rl));
        if (r && !r.err && !r.tooHigh) {
          cartItems[idx] = { id: v[2], quantity: r.rolki };
          h += '<span class="akc-meta">' + esc(v[0] || ('Rolka ' + rw + '×' + rl + ' cm')) + ' · potrzebujesz ' + r.rolki + ' ' + plural(r.rolki, 'rolkę', 'rolki', 'rolek') + '</span>';
          h += '<span class="akc-price">' + money(v[3] * r.rolki) + ' <small>(' + r.rolki + ' × ' + money(v[3]) + ')</small></span>';
        } else {
          h += '<span class="akc-meta">Ta rolka jest za krótka na Twoją ścianę — zobacz szczegóły na karcie produktu.</span>';
        }
      } else {
        h += '<span class="akc-meta">Wzór chwilowo niedostępny.</span>';
      }
      h += '<div class="akc-actions">';
      if (cartItems[idx]) h += '<button type="button" class="apk-btn" data-akt-add="' + idx + '">' + esc(C.addLabel || 'Dodaj do koszyka') + '</button>';
      h += '<a class="apk-btn apk-btn--ghost" href="' + esc(href) + '" target="_blank" rel="noopener">Zobacz wzór</a>';
      h += '</div><div data-akt-msg="' + idx + '"></div></div></div>';
      return h;
    }

    // --- render ---------------------------------------------------------------------
    function render() {
      var d = input(), err = validate(d);
      if (err) {
        runId++;
        var empty = d.mode === 'sciana' ? (d.w < 30 || d.h < 30) : (d.L < 50 || d.W < 50 || d.h < 50);
        out.innerHTML = empty ? '<div class="apk-placeholder">' + esc(err) + '</div>' : '<div class="apk-msg apk-msg--err">' + esc(err) + '</div>';
        return;
      }
      var my = ++runId;
      calcCache = {};
      var r = calc(d, C.rollW || 53, C.rollL || 1000);
      calcCache[(C.rollW || 53) + 'x' + (C.rollL || 1000)] = r;
      if (r.err) { out.innerHTML = '<div class="apk-msg apk-msg--err">' + esc(r.err) + '</div>'; return; }
      if (r.tooHigh) { out.innerHTML = '<div class="apk-msg apk-msg--err">Ściana jest wyższa niż długość rolki (' + fmt(r.rl / 100, 2) + ' m). Przy takiej wysokości napisz do nas — dobierzemy tapetę.</div>'; return; }

      var same = r.longest === r.shortest, saved = r.rectRolls - r.rolki, h = '';
      h += '<div class="apk-result-top"><span class="apk-count">' + r.rolki + ' ' + plural(r.rolki, 'rolka', 'rolki', 'rolek') + '</span>' +
        '<span class="apk-layout">' + fmt(r.rw) + ' cm × ' + fmt(r.rl / 100, 2) + ' m' + (d.extra ? ', w tym 1 zapasu' : '') + '</span></div>';
      h += '<ul class="apk-stats">' +
        '<li><b>' + r.all.length + ' ' + plural(r.all.length, 'pas', 'pasy', 'pasów') + '</b><span>' + (same ? 'po ' + fmt(r.longest) + ' cm długości' : 'od ' + fmt(r.shortest) + ' do ' + fmt(r.longest) + ' cm') + '</span></li>' +
        (saved > 0
          ? '<li><b>' + saved + ' ' + plural(saved, 'rolka', 'rolki', 'rolek') + ' mniej</b><span>dzięki krótkim pasom z resztek</span></li>'
          : '<li><b>' + r.perRoll + ' ' + plural(r.perRoll, 'pas', 'pasy', 'pasów') + '</b><span>z jednej rolki' + (same ? '' : ' (najdłuższe)') + '</span></li>') +
        '<li><b>' + fmt(r.area, 2) + ' m²</b><span>powierzchnia do pokrycia</span></li>' +
        '</ul>';
      h += d.mode === 'sciana' ? previewWall(d, r) : previewRoom(d, r);
      h += '<div class="apk-dims"><span>Linie przerywane — pasy po ' + fmt(r.rw) + ' cm</span><span>' +
        (d.raport ? 'Raport ' + d.raport + ' cm wliczony w długość pasa' : 'Do pasa doliczamy ' + d.trim + ' cm na docięcie') + '</span></div>';
      if (d.mode === 'pokoj') {
        h += '<p class="akc-strips">' + r.strips.length + ' ' + plural(r.strips.length, 'pełny pas', 'pełne pasy', 'pełnych pasów') + ' po ' + fmt(r.longest) + ' cm' +
          (r.shortS.length ? ' i ' + r.shortS.length + ' ' + plural(r.shortS.length, 'krótki', 'krótkie', 'krótkich') + ' nad drzwiami i przy oknach (' + r.shortS.map(function (x) { return fmt(x); }).join(', ') + ' cm)' : '') +
          '. Rozmieszczenie okien i drzwi na rysunku jest orientacyjne.</p>';
      } else if (!same || r.side.length) {
        h += '<p class="akc-strips">Pasy na ścianie: ' + r.strips.map(function (x) { return fmt(x); }).join(', ') + ' cm' +
          (r.side.length ? '. Boki występu: ' + r.side.map(function (x) { return fmt(x); }).join(', ') + ' cm' : '') +
          '. Układamy je w rolkach od najdłuższego — krótkie pasy wycinasz z resztek.</p>';
      }

      var room = val('[data-akt-room]'), motif = val('[data-akt-motif]');
      out.innerHTML = h + '<p class="akc-h">Dobieram tapety…</p>';
      findWzory(room, motif).then(function (found) {
        if (my !== runId) return;
        var data = found.res, html = h;
        cartItems = [];
        var label = function (t) { return (C.names && C.names[t]) || t.replace(/-/g, ' '); };
        if (data.items && data.items.length) {
          var head = (!room && !motif) ? 'Polecane tapety'
            : (found.exact ? 'Tapety' + (room ? ' — ' + label(room) : '') + (motif ? (room ? ', ' : ' — ') + label(motif) : '') : 'Polecane tapety');
          html += '<p class="akc-h">' + esc(head) + (data.count ? ' <span class="akc-meta" style="display:inline">(' + data.count + ' ' + plural(data.count, 'wzór', 'wzory', 'wzorów') + ')</span>' : '') + '</p>';
          if (!found.exact && (room || motif)) {
            html += '<p class="akc-info">Nie mamy wzorów dla: ' + esc([room, motif].filter(Boolean).map(label).join(' + ')) +
              '. Pokazujemy: ' + esc(found.tags.length ? found.tags.map(label).join(' + ') : 'wszystkie tapety') + '.</p>';
          } else if (!room && !motif) {
            html += '<p class="akc-info">Wybierz pomieszczenie albo motyw, a zawęzimy wzory. Na razie pokazujemy najczęściej wybierane. Cena obejmuje policzoną liczbę rolek, klej jest w zestawie.</p>';
          }
          html += '<div class="akc-list" data-akt-list>' + data.items.map(function (it, i) { return wzorHtml(it, d, i); }).join('') + '</div>';
          if (data.pages > 1) html += '<button type="button" class="apk-btn apk-btn--ghost akc-more" data-akt-more data-page="2">Pokaż więcej wzorów</button>';
          html += '<a class="akc-all" href="' + esc(ROOT_URL + 'collections/' + C.kolHandle + (found.tags.length ? '/' + found.tags.join('+') : '')) + '" target="_blank" rel="noopener">Zobacz wszystkie w kolekcji ↗</a>';
        } else {
          html += '<p class="akc-h">Tapety</p><p class="apk-tip">' + esc(C.emptyText) + '</p>';
        }
        if (C.fotoUrl && d.mode === 'sciana') html += '<p class="akc-info" style="margin-top:14px">Wolisz jeden duży obraz na całą ścianę? <a href="' + esc(C.fotoUrl) + '">Policz fototapetę</a>.</p>';
        out.innerHTML = html;
        bindAdd();
        var more = $('[data-akt-more]');
        if (more) more.addEventListener('click', function () {
          var page = +more.getAttribute('data-page');
          more.disabled = true; more.textContent = 'Wczytuję…';
          loadWzory(found.tags, page).then(function (nx) {
            if (my !== runId) return;
            var list = $('[data-akt-list]'), start = cartItems.length, tmp = document.createElement('div');
            tmp.innerHTML = (nx.items || []).map(function (it, i) { return wzorHtml(it, d, start + i); }).join('');
            while (tmp.firstChild) list.appendChild(tmp.firstChild);
            bindAdd(list);
            if (page < nx.pages) { more.disabled = false; more.textContent = 'Pokaż więcej wzorów'; more.setAttribute('data-page', page + 1); }
            else more.remove();
          });
        });
      });
    }

    function bindAdd(scope) {
      Array.prototype.slice.call((scope || root).querySelectorAll('[data-akt-add]')).forEach(function (btn) {
        if (btn.__akt) return;
        btn.__akt = true;
        btn.addEventListener('click', function () {
          var idx = +btn.getAttribute('data-akt-add'), it = cartItems[idx];
          var msg = root.querySelector('[data-akt-msg="' + idx + '"]');
          if (!it) return;
          var label = btn.textContent;
          btn.disabled = true; btn.textContent = 'Dodaję…'; msg.innerHTML = '';
          fetch(ROOT_URL + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: it.id, quantity: it.quantity, properties: { _Kalkulator: 'tapety' } }] })
          })
            .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
            .then(function () { window.location.href = ROOT_URL + 'cart'; })
            .catch(function (err) {
              btn.disabled = false; btn.textContent = label;
              msg.innerHTML = '<div class="apk-msg apk-msg--err">' + esc((err && err.description) || 'Nie udało się dodać do koszyka. Spróbuj ponownie.') + '</div>';
            });
        });
      });
    }

    // --- kształt ściany i schemat ------------------------------------------------------
    var SCHEMAT = {
      prawy: { p: '14,100 14,14 104,14 186,62 186,100', t: [['A', 100, 116], ['B', 4, 60], ['C', 196, 84], ['D', 59, 9]], l: [[14, 106, 186, 106], [8, 14, 8, 100], [192, 62, 192, 100], [14, 6, 104, 6]] },
      lewy: { p: '14,100 14,62 96,14 186,14 186,100', t: [['A', 100, 116], ['B', 196, 60], ['C', 4, 84], ['D', 141, 9]], l: [[14, 106, 186, 106], [192, 14, 192, 100], [8, 62, 8, 100], [96, 6, 186, 6]] },
      dwa: { p: '14,100 14,62 76,14 124,14 186,62 186,100', t: [['A', 100, 116], ['B', 100, 60], ['C', 4, 84], ['D', 100, 9]], l: [[14, 106, 186, 106], [100, 14, 100, 100], [8, 62, 8, 100], [76, 6, 124, 6]] }
    };
    function setShape(s) {
      shape = s;
      $$('[data-akt-shape]').forEach(function (b) { b.setAttribute('aria-checked', String(b.getAttribute('data-akt-shape') === s)); });
      var skos = s !== 'prosta';
      $('[data-akt-skos]').hidden = !skos;
      $('[data-akt-lw]').textContent = skos ? 'A · Szerokość przy podłodze (cm)' : 'Szerokość ściany (cm)';
      $('[data-akt-lh]').textContent = skos ? 'B · Wysokość najwyższa (cm)' : 'Wysokość ściany (cm)';
      $('[data-akt-ld]').innerHTML = s === 'dwa'
        ? 'D · Szerokość płaskiej góry (cm)<span class="apk-hint">0, gdy skosy schodzą się w szczycie.</span>'
        : 'D · Szerokość pełnej wysokości (cm)<span class="apk-hint">Od narożnika do miejsca, gdzie zaczyna się skos.</span>';
      $('[data-akt-tip]').textContent = skos
        ? 'Wysokości mierz pionowo od podłogi. Pod skosem pasy są krótsze, więc wychodzą z resztek rolek.'
        : 'Zmierz ścianę w kilku miejscach i wpisz największe wyniki. Gniazdek i włączników nie odejmuj — tapetę docina się wokół nich.';
      var box = $('[data-akt-schemat]'), sc = SCHEMAT[s];
      if (!sc) { box.hidden = true; box.innerHTML = ''; return; }
      var h = '<svg viewBox="-6 0 212 124" aria-hidden="true"><polygon points="' + sc.p + '" fill="#ECE4D6" style="stroke:var(--apk-accent)" stroke-width="2" stroke-linejoin="round"/>';
      sc.l.forEach(function (l) { h += '<line x1="' + l[0] + '" y1="' + l[1] + '" x2="' + l[2] + '" y2="' + l[3] + '" stroke="#202D3D" stroke-opacity=".55" stroke-width="1.2" stroke-dasharray="3 2"/>'; });
      sc.t.forEach(function (t) { h += '<circle cx="' + t[1] + '" cy="' + (t[2] - 4) + '" r="7.5" fill="#202D3D"/><text x="' + t[1] + '" y="' + t[2] + '" font-size="11" font-weight="700" text-anchor="middle" fill="#fff" font-family="inherit">' + t[0] + '</text>'; });
      box.innerHTML = h + '</svg>';
      box.hidden = false;
    }

    // --- zdarzenia ---------------------------------------------------------------------
    function rerender() { var d = input(); if (filled(d) && !validate(d)) render(); }
    $$('[data-akt-mode]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        mode = tab.getAttribute('data-akt-mode');
        $$('[data-akt-mode]').forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); });
        $$('[data-akt-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-akt-pane') !== mode; });
        var d = input();
        if (filled(d)) render(); else { runId++; out.innerHTML = '<div class="apk-placeholder">' + esc(mode === 'pokoj' ? 'Podaj długość, szerokość i wysokość pokoju oraz okna i drzwi, żeby zobaczyć wynik.' : 'Podaj szerokość i wysokość ściany, żeby zobaczyć wynik.') + '</div>'; }
      });
    });
    $$('[data-akt-shape]').forEach(function (b) { b.addEventListener('click', function () { setShape(b.getAttribute('data-akt-shape')); rerender(); }); });
    $('[data-akt-wyst]').addEventListener('change', function () { $('[data-akt-wyst-pola]').hidden = !this.checked; rerender(); });
    $('[data-akt-go]').addEventListener('click', render);
    $$('input[type="number"]').forEach(function (el) {
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); render(); } });
    });
    $$('[data-akt-raport],[data-akt-extra],[data-akt-room],[data-akt-motif]').forEach(function (el) {
      el.addEventListener('change', rerender);
    });
    // wymiary z adresu: ?w=&h= (ściana) albo ?l=&s=&h= (pokój)
    try {
      var q = new URLSearchParams(window.location.search);
      if (q.get('l') && q.get('s')) {
        $('[data-akt-mode="pokoj"]').click();
        $('[data-akt-pl]').value = q.get('l'); $('[data-akt-pw]').value = q.get('s'); if (q.get('h')) $('[data-akt-ph]').value = q.get('h');
        render();
      } else if (q.get('w') && q.get('h')) {
        $('[data-akt-w]').value = q.get('w'); $('[data-akt-h]').value = q.get('h');
        render();
      }
    } catch (e) {}
    setShape(shape);
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-akt]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
